import { useState, useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';

export const useHerdsmanForm = (updateItem, onSubmitAddEdit, onCloseModal, triggerSubmit, setTriggerSubmit) => {
    const buttonSubmitRef = useRef(null);
    const [checkActive, setCheckActive] = useState(updateItem?.isActived ?? true);
    const [herdsmanType, setHerdsmanType] = useState(updateItem?.herdsmanType ?? 1);

    const { register, handleSubmit, errors, setValue, control } = useForm({
        mode: "all",
        reValidateMode: "onBlur",
    });

    useEffect(() => {
        if (updateItem) {
            setCheckActive(updateItem.isActived);
            setHerdsmanType(updateItem.herdsmanType || 1);
            
            // Set values for fields that might not be handled by defaultValue
            const fields = [
                "departmentId", "groupId1", "groupId2", "zionId", 
                "districtId", "positionId", "wMTeamId", "zionAreaId", 
                "branchId", "dateOfBirth", "herdsmanTakeCareId", "herdsmanType"
            ];
            fields.forEach(field => {
                let value = updateItem[field];
                if (field === "zionId" && !value) value = 21;
                if (field === "herdsmanType" && !value) value = 1;
                setValue(field, value);
            });
        } else {
            setValue("zionId", 21);
            setValue("herdsmanType", 1);
        }
    }, [updateItem, setValue]);

    const onSubmit = (data) => {
        if (!data) return;

        if (data.avaImage && data.avaImage.length > 0) {
            data.avaImage = data.avaImage[0];
        }

        onSubmitAddEdit({ 
            ...data, 
            IsCreateUser: false, 
            id: updateItem?.id, 
            documentUploadId: updateItem?.documentUploadId, 
            fromCustomerId: updateItem?.fromCustomerId, 
            herdsmanType: herdsmanType, 
            zionId: 21 
        });
        onCloseModal();
    };

    useEffect(() => {
        if (!triggerSubmit) return;
        buttonSubmitRef.current.click();
        setTriggerSubmit(false);
    }, [triggerSubmit, setTriggerSubmit]);

    return {
        register, handleSubmit, errors, setValue, control,
        checkActive, setCheckActive,
        herdsmanType, setHerdsmanType,
        buttonSubmitRef,
        onSubmit
    };
};
